import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import Pulse from "@ubisend/pulse-boost";

Pulse.render();